var React = require('react');

function Beepboop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.75586 5.53027H17.2559","stroke":"#023247","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M6.75633 9.53027L3.46633 6.24027C3.07633 5.85027 3.07633 5.22027 3.46633 4.83027L6.75633 1.53027","stroke":"#023247","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M16.7559 14.5303H3.25586","stroke":"#023247","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M13.7559 10.5303L17.0459 13.8203C17.4359 14.2103 17.4359 14.8403 17.0459 15.2303L13.7559 18.5203","stroke":"#023247","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","key":3})]);
}

Beepboop.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = Beepboop;

Beepboop.default = Beepboop;
